// regex that blocks all special chars except commas and apostrophes
export const blockMostSpecialChars = (str: string) => {
  return !/[~`!@#$%\^&()_*+=\-\[\]\\;/{}|\\":<>\?]/g.test(str);
};